import { Button, Dialog, DialogActions, DialogContent, Switch, DialogContentText, Grid, Stack, Tooltip,Box } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { useEffect, useMemo, useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useCallback } from "react";
import { useRef } from "react";
import jwtDecode from "jwt-decode";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import DialogBox from "../../utilities/DialogBox";
import DiscountGrid from "../../discount-master/DiscountGrid";

const CustomerDiscountData = (props) => {
    const [gridRef, setGridRef] = useState();
    const childRef = useRef();
    const [autoSizeMode, setAutoSizeMode] = useState(true)
    const [discountSelectedRows, setDiscountSelectedRows] = useState([]);
    const [updateData, setUpdateData] = useState([]);
    const [successMsg, setSuccessMsg] = useState();
    const [error, setError] = useState();
    const [saveBtnDisable, setSaveBtnDisable] = useState(true);
    const [priUpdate, setPriUpdate] = useState([]);
    const [priRequest, setPriRequest] = useState([]);
    const [priApprove, setPriApprove] = useState([]);
    const [saveOpen, setSaveOpen] = useState(false);
    const [priView, setPriView] = useState([]);
    const [yearOptions, setYearOptions] = useState();
    const [year, setYear] = useState();
    const [discountStatus, setDiscountStatus] = useState('APPROVED');
    const [statusOptions, setStatusOptions] = useState([
        { label: 'New', value: 'NEW' },
        { label: 'Approved', value: 'APPROVED' },
        { label: 'Rejected', value: 'REJECTED' },
        { label: 'Pending For Approval', value: 'PENDING_APPROVAL' },
    ]);
    const [editMode,setEditMode] = useState(false);
    const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));

useEffect(() => {
        if (discountSelectedRows.length > 0 && discountSelectedRows[0]?.id) {
            setEditMode(true)
        } else {
            setEditMode(false)
        }
    }, [discountSelectedRows]);
    useEffect(() => {
        const arg = 'ROLE_';
        const roles = token?.scope.filter(value => {
            return value.startsWith(arg);
        });
        const users = async () => {
            try {
                await Promise.all(roles.map(async (role) => {
                    const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.user}/privilegesByRole?roleName=${role}`;
                    try {
                        const checkRole = await OAuthService.getList(userUrl);
                        checkRole.data?.result?.filter((role) => {
                            if (role.id === "PRIVILEGE_REQDISC") {
                                priRequest.push(role)
                                setPriRequest(priRequest)
                            }
                            if (role.id === "PRIVILEGE_APPDISC") {
                                priApprove.push(role)
                                setPriApprove(priRequest)
                            }
                            if (role.id === "PRIVILEGE_VIDISC") {
                                priView.push(role)
                                setPriView(priView)
                            }
                            if (role.id === "PRIVILEGE_UPDDISC") {
                                priUpdate.push(role)
                                setPriUpdate(priUpdate)
                            }
                            return role
                        })
                    } catch {

                    }
                }));
            } catch {

            }
        }
        users();
        const cyear = (new Date()).getFullYear();
        let years = Array.from(new Array(20), (val, index) => { return { label: cyear - index, value: cyear - index } });
        years = [{ label: cyear + 1, value: cyear + 1 }, ...years]
        setYear(cyear)
        setYearOptions(years);
    }, []);

    const discountEdit = (updateData.length > 0 && discountSelectedRows.length > 0) && updateData.filter((data) => {
        if (data.id === discountSelectedRows[0]?.id) {
            return data
        }
    });

    const submitApproval = (priRequest && priRequest.length > 0) || token?.scope.includes("PRIVILEGE_REQDISC");
    const approveReject = (priApprove && priApprove.length > 0) || token?.scope.includes("PRIVILEGE_APPDISC");

    useEffect(() => {
        props.setAllSuccessMsg(successMsg)
    }, [successMsg]);

    useEffect(() => {
        props.setAllErrorMsg(error)
    }, [error])

    const handleSaveClose = () => {
        setSaveOpen(false)
    }
    const handleSaveOpen=()=>{
        if(token?.scope?.includes("ROLE_MD")){
            handleSaveDiscount()

        }else{

            setSaveOpen(true)
        }

    }

    const onYearDropdownChange = useCallback((data) => {
        setYear(data.value);
    }, [discountStatus]);

    const onStatusDropdownChange = useCallback((data) => {
        setDiscountStatus(data.value);
    }, [year]);

      const handleSaveAndApproveDiscount = () => {
        const childelement = childRef.current;
        childelement.handleSaveAndApproveDiscount();
    }
    
    const handleSaveDiscount = () => {
        const childelement = childRef.current;
        childelement.handleSaveDiscount();
    }
    const onResetColumnState = () => {
        const childelement = childRef.current;
        childelement.onResetColumnState();
    }
    const handleSubmitDeclineDiscount = () => {
        const childelement = childRef.current;
        childelement.handleSubmitDeclineDiscount();
    }
    const handleSubmitApprovalDiscount = () => {
        const childelement = childRef.current;
        childelement.handleSubmitApprovalDiscount();
    }
    const handleRequestApprovalDiscount = () => {
        const childelement = childRef.current;
        childelement.handleRequestApprovalDiscount();
    }
    const onBtExport = () => {
        const childelement = childRef.current;
        childelement.onBtExport();
    }
    const loadDiscountColumns = (value) => {
        const childelement = childRef.current;
        childelement.loadDiscountColumns(value);
    }
    const toggleAutoSize = () => {
        const childelement = childRef.current;
        childelement.toggleAutoSize(autoSizeMode);
        setAutoSizeMode(!autoSizeMode)
    }

    const handleSuccessMsg = (msg) => {
        if (msg) {
            setSuccessMsg(msg)
        }
    }

    const handleSelectedRows = (selected) => {
        setDiscountSelectedRows(selected ? selected : [])
    }
    const handleUpdateData = (updated) => {
        setUpdateData(updated ? updated : [])
    }
    const handleSaveBtnDisable = (state) => {
        setSaveBtnDisable(state === false ? false : true)
    }
    const handleError = (eror) => {
        setError(eror ? eror : '')
    }
    const handleGridRef = (ref) => {
        setGridRef(ref)
    }

    useEffect(() => {
        handleSuccessMsg();
        handleSelectedRows();
        handleUpdateData();
        handleSaveBtnDisable();
        handleError();
        handleGridRef();
    }, []);

    const handleDefaultGridState = () => {
        gridRef.current.api.setFilterModel(null);
        gridRef.current.columnApi.resetColumnState();
        const childelement = childRef.current;
        childelement.onResetColumnState();
    };

    return (<>

        <Grid className="flex flex-row mb-10" justifyContent="flex-end" alignItems="flex-end">
            <Stack direction={'row'} spacing={2}>
                <label className="pt-12">Year</label>
                <Select name="year"
                    value={(yearOptions && year) && yearOptions.filter(obj => year === obj.value)}
                    onChange={onYearDropdownChange}
                    className="w-[110px]"
                    options={yearOptions}
                    styles={customStyles()}
                />
                <label className="pt-12">Status</label>
                <Select name="year"
                    value={(statusOptions && discountStatus) && statusOptions.filter(obj => discountStatus === obj.value)}
                    onChange={onStatusDropdownChange}
                    className="w-[110px]"
                    options={statusOptions}
                    styles={customStyles()}
                />
                {((discountSelectedRows.length > 0) || discountEdit.length > 0) && <Button variant="contained"
                    color="secondary"
                    disabled={saveBtnDisable}
                    onClick={handleSaveOpen}
                >
                    <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                </Button>}
                {(discountSelectedRows.length > 0 && discountSelectedRows[0]?.approvalStatus === 'NEW' && submitApproval) && <Tooltip title="Submit For Approval">
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleRequestApprovalDiscount}
                        disabled={discountSelectedRows[0]?.id ? false : true}
                    >
                        <i class="material-icons">thumb_up</i>
                    </Button></Tooltip>}
                {(discountSelectedRows.length > 0 && discountSelectedRows[0]?.id && approveReject && discountSelectedRows[0]?.approvalStatus === 'PENDING_APPROVAL') && <Tooltip title="Approved"><Button
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmitApprovalDiscount}
                >
                    <i class="material-icons">done</i>
                </Button></Tooltip>}
                {(discountSelectedRows.length > 0 && discountSelectedRows[0]?.id && approveReject && discountSelectedRows[0]?.approvalStatus === 'PENDING_APPROVAL') && <Tooltip title="Reject"><Button
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmitDeclineDiscount}
                >
                    <i class="material-icons">cancel</i>
                </Button></Tooltip>}
                {handleSaveDiscount && <Dialog
                    open={saveOpen}
                    onClose={handleSaveClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent sx={{ p: 3 }}>
                        <DialogContentText id="alert-dialog-description"  sx={{ mb: 2 }}>
                            Are you sure you want to save discount?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions  sx={{ px: 3, pb: 2 }}>
                        {!editMode&&

                        
                         <Button   variant="contained"
                                              color="secondary" onClick={handleSaveAndApproveDiscount}>Save & Send for Approval</Button>}
                        <Button onClick={handleSaveDiscount}>Save</Button>
                        <Button onClick={handleSaveClose} autoFocus>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>}
                <Button
                    onClick={toggleAutoSize}
                    variant="contained"
                    color="error"
                    sx={{ height: 30, minHeight: 30, maxHeight: 30, fontSize: 11 }}
                >
                    {autoSizeMode ? 'Auto-Size Columns' : 'Reset Columns'}
                </Button>
                {gridRef && (
                    <Tooltip title={"Default Grid State"}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleDefaultGridState}
                            style={{ marginBottom: "5px", fontWeight: "bold" }}
                        >
                            <FuseSvgIcon>material-outline:grid_on</FuseSvgIcon>
                        </Button>
                    </Tooltip>
                )}
            </Stack>
        </Grid>


        <Stack style={{ height: '400px' }}>
            <DiscountGrid
                ref={childRef}
                discountStatus={discountStatus}
                discountType={'Customer'}
                customerId={props.custNum}
                customerName={props.custName}
                year={year}
                handleSaveDiscount={handleSaveDiscount}
                handleSaveAndApproveDiscount={handleSaveAndApproveDiscount}
                onResetColumnState={onResetColumnState}
                handleSubmitDeclineDiscount={handleSubmitDeclineDiscount}
                handleSubmitApprovalDiscount={handleSubmitApprovalDiscount}
                handleRequestApprovalDiscount={handleRequestApprovalDiscount}
                onBtExport={onBtExport}
                loadDiscountColumns={loadDiscountColumns}
                successMsg={handleSuccessMsg}
                updateData={handleUpdateData}
                selectedRows={handleSelectedRows}
                saveBtnDisable={handleSaveBtnDisable}
                pagination={false}
                handleSaveClose={handleSaveClose}
                error={handleError}
                gridRef={handleGridRef}
            />
        </Stack>
    </>);
}

export default CustomerDiscountData;
